// 导出页面为PDF格式
import html2Canvas from 'html2canvas'
import JsPDF from 'jspdf'
import {Spin} from 'view-design'
export default{
  install (Vue, options) {
    Vue.prototype.getPdf = function (title) {
       let pdfDom = document.querySelector('#pdfDom') 
       console.log(pdfDom)
       let html = document.querySelector("html");
       html.style.zoom=1;
      html2Canvas(pdfDom, {
        allowTaint: true,
      }).then(function (canvas) 
      {
        html.style.zoom='80%';
        let contentWidth = canvas.width
        let contentHeight = canvas.height
        let pageHeight = contentWidth / 592.28 * 841.89
        let leftHeight = contentHeight
        let position = 0
        let imgWidth = 595.28
        let imgHeight = 592.28 / contentWidth * contentHeight
        let pageData = canvas.toDataURL('image/jpeg', 1.0)
        
        let PDF = new JsPDF('', 'pt', 'a4')
        if (leftHeight < pageHeight) {
          PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
        } else {
          while (leftHeight > 0) {
            PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
            leftHeight -= pageHeight
            position -= 841.89
            if (leftHeight > 0) {
              PDF.addPage()
            }
          }
        }
        PDF.save(title + '.pdf')
      }
      )
      return true
    }
  }
}


// WEBPACK FOOTER //
// ./src/util/htmlToPdf.js